
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carBooking/carBookRide",
      function () {
        return require("private-next-pages/carBooking/carBookRide.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/carBooking/carBookRide"])
      });
    }
  